export const DESK_REFETCH_MS = 60_000

export function visibleTabRefetch(ms: number) {
  return {
    refetchInterval: ms,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true as const,
  }
}

export function isFilterChangeFetching(isFetching: boolean, isPlaceholderData: boolean): boolean {
  return isFetching && isPlaceholderData
}
